module.exports = __webpack_public_path__ + "img/youye2.gif";